import Vue from 'vue';
import VueTelInput from 'vue-tel-input';

Vue.use(VueTelInput, {
  dynamicPlaceholder: true,
  validCharactersOnly: true,
  preferredCountries: ['RU', 'US'],
  autocomplete: 'off'
});
